import { firestoreDocumentById } from '../firebase/firestore';
import getKitapoService from '../services/KitapoService';
import { ACLChecker } from './ACLChecker';

export class ReflectionAccessValidator {
  constructor(reflectionId, organizationId, analysisIds) {
    this.reflectionId = reflectionId;
    this.organizationId = organizationId;
    this.analysisIds = analysisIds;
  }

  // This ensure that all entities in the ACL has access to all analyses in the reflection.
  async validate(acl) {
    console.log(`Validate reflection ${this.reflectionId} supporting analysis acl with ${acl.length} acl entries`);

    const check = async (func) => {
      const analyses = await this.fetchAnalyses();

      await Promise.all(
        acl.map(async accessor => {
          await Promise.all(
            analyses.map(async analysis => {
              const analysisChecker = await ACLChecker.init(this.organizationId, analysis.acl);

              await func(accessor, analysisChecker, analysis);
            }),
          );
        }),
      );
    };

    await check(async (accessor, analysisChecker, analysis) => {
      if (accessor.entityType === 'Group') {
        if (!analysisChecker.groupHasAccess(accessor.entityId)) {
          await giveAccessToGroup(analysis, this.organizationId, accessor.entityId);
        }
      }
    });

    // It's important to check for users after group to not give uneccessary permissions to user
    // that would have access to the analyses with a group that was not present before.
    await check(async (accessor, analysisChecker, analysis) => {
      if (accessor.entityType === 'User') {
        if (!analysisChecker.userHasAccess(accessor.entityId)) {
          await giveAccessToUser(analysis, accessor.entityId);
        }
      }
    });
  }

  async fetchAnalyses() {
    return Promise.all(this.analysisIds.map(async (analysisId) => {
      const ref = firestoreDocumentById('analyses', analysisId);
      const snapshot = await ref.get();
      return snapshot.data();
    }));
  }
}

async function giveAccessToUser(analysis, userId) {
  console.log(`Giving access to user ${userId} to analysis ${analysis.id}`, analysis);

  const snapshot = await firestoreDocumentById('users', userId).get();
  const user = snapshot.data();
  const displayName = `${user.firstName} ${user.lastName}`;

  const service = getKitapoService();
  analysis.acl.push({
    displayName,
    entityType: 'User',
    entityId: userId,
    permission: 'Owner',
  });

  await service.saveAnalysis(analysis);
}

async function giveAccessToGroup(analysis, organizationId, groupId) {
  console.log(`Giving access to group ${groupId} to analysis ${analysis}`);

  const snapshot = await firestoreDocumentById(`organizations/${organizationId}/groups`, groupId).get();
  const group = snapshot.data();
  const displayName = group.name;

  const service = getKitapoService();
  analysis.acl.push({
    displayName,
    entityType: 'Group',
    entityId: groupId,
    permission: 'Owner',
  });

  await service.saveAnalysis(analysis);
}
